import { render } from "./content.vue?vue&type=template&id=56734ae8&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"

import "./content.vue?vue&type=style&index=0&id=56734ae8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56734ae8"

export default script